import React from 'react';
import { DatePicker, DatePickerProps as RSDatePickerProps } from 'rsuite';
import { FieldProps } from 'formik';
import dayjs from 'dayjs';
import { TypeAttributes } from 'rsuite/lib/@types/common';
import { FULL_DATE, FULL_TIME, HOUR_MINUTE } from '@/constants/dateFormat';

export interface DatePickerProps extends Omit<RSDatePickerProps, 'form'>, FieldProps {}

const BicesterDatePicker = ({
  field,
  form,
  className,
  style,
  format = FULL_DATE,
  placement,
  placeholder = ' ',
  onClean,
  onChange,
  ...props
}: {
  className?: string;
  style?: any;
  format?: string;
  placement?: TypeAttributes.Placement;
  placeholder?: React.ReactNode;
  onClean?: (event: React.SyntheticEvent<HTMLElement, Event>) => void;
  [rest: string]: any;
} & DatePickerProps) => {
  return (
    <DatePicker
      className={className}
      style={style}
      format={format}
      placement={placement}
      placeholder={placeholder}
      value={
        field.value
          ? typeof field.value === 'string'
            ? new Date(
                [HOUR_MINUTE, FULL_TIME].includes(format) // HH:mm | HH:mm:ss 这种格式的数据时间选择器不能直接解析，需要另外处理
                  ? `${dayjs().format(FULL_DATE)} ${field.value}`
                  : field.value
              )
            : field.value
          : null
      }
      onChange={(value, event) => {
        form.setFieldValue(field.name, dayjs(value).format(format));
        field.onChange(event);
        onChange && onChange(value);
      }}
      onClean={(event) => {
        form.setFieldValue(field.name, '');
        onClean && onClean(event);
      }}
      oneTap={!format.includes('HH:mm')} // 精确到时分的选择器需要有确定按钮
      {...props}
    />
  );
};

export default BicesterDatePicker;
